import React from 'react';
import { connect } from "react-redux";
import createItem from './../../../../API/Client/CreateClientType.js'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from './../../../../Global/loader'
import GetCountries from './../../../../API/Client/GetCountries'
import Select from 'react-select'
import { withNamespaces } from 'react-i18next';
import { Form, Row, Col, Button} from 'react-bootstrap';

class CreateClientTypes extends React.Component {
    constructor(props) {
        super(props); 
        this.submitCreate = this.submitCreate.bind(this);
    }

    state={
        loading: false,
        client_type_name: "",
        countries: [],
        country: null
    }

    componentDidMount = async () => {
        document.title = this.props.t("Client types") + "-" + this.props.t("Create")

         //get countries
         let items = await GetCountries()       
         let countryList = []
         
         await items.data.countries
             .map((data, index) =>{
             let oneItem = {value: data.uuid , label: data.country_name }
             countryList.push(oneItem)
             return null
         })
             
         await this.setState({
             countries: countryList,
             country: countryList[0]
         })
 
         await this.setState({
             loading: false            
         })
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    submitCreate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()        

        let createPP = await createItem(
            this.state.client_type_name, 
            this.state.country.value
        )

        if(createPP.data.status === 200){ 
            store.addNotification({
                title: this.props.t('Success!'),
                message: "Creating was successful",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  pauseOnHover: true
                }
            });

            this.setState({ loading: false })
            this.props.goBack()
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('There was an error creating the client type, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (            
            this.state.loading ?
                <div className="loader-container">
                    <Loader />
                </div>
            :
            <Form className="form-container">
                <Row>          
                    <Col sm={12} xl={4} lg={6}>
                        <Form.Group as={Row}>
                            <Form.Label column md="4">{t('Country')}</Form.Label>
                            <Col sm={8}>
                                <Select
                                    options={this.state.countries} 
                                    onChange={(values) => this.handleCountryChange(values)}
                                    isClearable
                                    isInvalid={this.state.country === null}
                                    value={this.state.country}
                                />
                            </Col>
                        </Form.Group>

                        <Form.Group as={Row}>
                            <Form.Label column md="4">{t('Name')}</Form.Label>
                            <Col sm={8}>
                                <Form.Control      
                                    id="client_type_name"                          
                                    type="text"
                                    value={this.state.client_type_name}
                                    onChange={e => this.handleChange(e)}
                                />
                            </Col>
                        </Form.Group>

                        <Col sm={12} className="button-container">
                            <Button    
                                className="btnSpremi"
                                onClick={(e) => this.submitCreate(e)}
                            >
                                {t('Save')}
                            </Button>
                        </Col>                                  
                    </Col>                        
    
                    
                </Row>           
                
                <Row className='back-button-container'>
                    <Button 
                        variant='default'
                        onClick={() => this.props.goBack()}
                    >
                        <BsBackspaceFill size={30} />  <strong>{t('Back')}</strong>
                    
                    </Button>
                </Row>
            </Form>
        )
    }
}
const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateClientTypes));


